import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen pt-32 pb-24">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="glass-effect border border-destructive/30 p-12 text-center"
          data-testid="payment-cancel-page"
        >
          <XCircle className="h-20 w-20 text-destructive mx-auto mb-8" />
          <h1 className="text-4xl md:text-5xl font-heading font-black mb-6">Payment Cancelled</h1>
          <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
            Your payment was cancelled. No charges have been made to your account. You can try again whenever you're ready.
          </p>
          <div className="space-y-4">
            <Link
              to="/register"
              data-testid="cancel-retry-btn"
              className="block px-8 py-4 bg-primary text-background hover:bg-primary/90 font-bold uppercase tracking-widest transition-all duration-300 neon-glow"
            >
              Try Again
            </Link>
            <Link
              to="/"
              data-testid="cancel-home-btn"
              className="block px-8 py-4 border border-primary/50 text-primary hover:bg-primary/10 font-bold uppercase tracking-widest transition-all duration-300"
            >
              Return to Home
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancel;
